import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Input } from 'antd'
import axios from 'axios'
import RenderGlossaryList from './RenderGlossaryList'

const RenderGlossary = ({ token }) => {
    const [datas, setDatas] = useState([])
    const [filteredDatas, setFilteredDatas] = useState(null)

    useEffect(() => {
        if (!token) return
        axios.get(process.env.REACT_APP_URL_GD6D, {
            params: { r: 'apiSav/getLexique' },
            headers: { Authorization: `Bearer ${token}` },
        }).then(resp => {
            const val = resp?.data?.data
            if (val) setDatas(Object.values(val))
        }).catch(() => {})
    }, [token])

    const onSearch = (e) => {
        const val = e.target.value
        if (val && val.length >= 2) {
            setFilteredDatas(datas.filter(d => d.title.toLowerCase().includes(val.toLowerCase())))
        } else {
            setFilteredDatas(null)
        }
    }

    return (
        <>
            <div className="sav-wrap-search">
                <Input.Search
                    placeholder="Rechercher"
                    onChange={onSearch}
                    allowClear
                    maxLength={20}
                    style={{ width: 200 }}
                />
            </div>
            <RenderGlossaryList datas={filteredDatas !== null ? filteredDatas : datas} />
        </>
    )
}

const mapStateToProps = state => ({
    token: state.user.token,
})

export default connect(mapStateToProps)(RenderGlossary)
